export default __webpack_public_path__ + "928ae46518dfa11526f1c5572499db84.png";